import { Box, Grid, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { useGetUserList } from "api/hooks/userAccounts";
import FormDialog from "components/modal";
import { FlexRow } from "components/FlexBox";
import ChangePasswordForm from "../forms/changePasswordForm";
import * as yup from "yup";
import { requester } from "api/pesabackend";



export default function UserTable({ setIsSuccess, setIsFailed }) {
  const [open, setOpen] = useState(false);
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const [isSubmittingData, setIsSubmittingData] = useState(false);
  const [clickedItem, setClickedItem] = useState("");
  const [modalView, setModalView] = useState("");
  const [newPassword, setNewPassword] = useState({ new_password: "", user: "" });
  const [validationErrors, setValidationErrors] = useState({});

  const { userList, isLoadingUserList } = useGetUserList(1, business_branch_id);

  const handleOpen = (modalView, row) => {
    setClickedItem(row)
    console.log(row)
    if (modalView==='changePassword') {
      setNewPassword((prev) => ({ ...prev, 'user': row.id }));
    }
    setModalView(modalView);
    setOpen(true);
  };

  const handleClose = () => {
    setModalView("");
    setClickedItem("");
    setNewPassword({ new_password: "", user: "" });
    setValidationErrors({});
    setOpen(false);
  };


  const handleSubmitDeactivate = async () => { 
    setIsSubmittingData(true);
    // const actionDetails = await requester.post()
    //   .then((response) => {
    //     handleClose();
    //     setIsSubmittingData(false);


    //   })
    //   .catch((error) => {


    //     setIsSubmittingData(false);
    //   })
  };

  const handleSubmitActivate = async () => {
    setIsSubmittingData(true);
    await requester.post()
      .then((response) => {
        handleClose();
        setIsSubmittingData(false);


      })
      .catch((error) => {


        setIsSubmittingData(false);
      })
  }

  const itemSchema = yup.object().shape({
    new_password: yup.string().required("required"),
  });

  const handleChangePassword = (event) => { 
    const { name, value } = event.target;
    setNewPassword((prev) => ({ ...prev, [name]: value }));
    if (!value.trim()) {
      setValidationErrors((prev) => ({ ...prev, [name]: `This is required` }));
    } else {
      setValidationErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmitPassword = async () => { 
    setIsSubmittingData(true);
    try {
      await itemSchema.validate(newPassword, { abortEarly: false });
    } catch (error) {
      const newError = {}
      error.inner.forEach(err => {
        newError[err.path] = err.message
      })
      setValidationErrors(newError);
      setIsSubmittingData(false);
      return
    }

    console.log(typeof(newPassword))
    console.log(JSON.stringify(newPassword))

    await requester.post('/acccounts/change_user_password', JSON.stringify(newPassword)) 
      .then((response) => {
        handleClose();
        setIsSubmittingData(false);
        setIsSuccess(true);        
      })
      .catch((error) => {
        setIsFailed(true)        
        setIsSubmittingData(false);
      })
  };

  return (
    <Box>
      <h4>User List</h4>
      <Box p="0.5rem" m="0.2rem">
        <Grid container spacing={4} className="alignHorizantal">
          <Grid xs>
          </Grid>
          <Grid xs></Grid>
          <Grid xs sx={{ textAlign: "right" }}>

          </Grid>
        </Grid>
      </Box>

      <ReportTable
        columns={[
          { label: "No.", width: 50 },
          { label: "Name", width: 170 },
          { label: "Username", width: 170 },
          { label: "Actions", align: "center" },
        ]}
        rows={userList}
        loading={isLoadingUserList}
        emptyMessage="No data found"
        renderRow={(row, index) => (
          <RRow key={row.id} index={index}>
            <RCell>{index + 1}</RCell>
            <RCell>{row.first_name} {row.last_name}</RCell>
            <RCell>{row.username}</RCell>
            <RCell align="center">
              <Button value={row.id} size="small" onClick={() => { handleOpen('changePassword', row);  }} > Change Password </Button>
              {row.status === 1 ?
                <Button value={row.id} size="small" color="error" onClick={() => { handleOpen('deactivateUser', row); }}> Deactivate</Button>
                :
                <Button value={row.id} size="small" color="success" onClick={() => { handleOpen('activateUser', row); }}> Activate</Button>
              }
            </RCell>
          </RRow>
        )}
      />
      {modalView === 'deactivateUser' ?
        <FormDialog
          title={`Deactivate ${ clickedItem.first_name } ${ clickedItem.last_name }'s User Account `}
          open={open}
          enableActions={true}
          content={
            <FlexRow>
              <Typography fontWeight={'bold'} color={'error'}>Are you sure you want to deactivate the user account for </Typography>
              <Typography fontWeight={'bold'} >: {clickedItem.first_name} {clickedItem.last_name}? </Typography>
            </FlexRow>
          }
          buttonText="Deactivate User"
          handleSubmit={handleSubmitDeactivate}
          isSubmitting={isSubmittingData}
          isSubmittingText={"Deactivating User, Please wait..."}
          handleClose={handleClose}
        /> : modalView === 'changePassword' ?
          <FormDialog
            title={`Change Password for ${ clickedItem.first_name } ${ clickedItem.last_name }`}
            open={open}
            enableActions={true}
            content={<ChangePasswordForm values={newPassword} errors={validationErrors} handleChange={handleChangePassword} />}
            buttonText="Change Password"
            handleSubmit={handleSubmitPassword}
            isSubmitting={isSubmittingData}
            isSubmittingText={"Changing Password, Please wait..."}
            handleClose={handleClose}
          /> : modalView === 'activateUser' ?
            <FormDialog
              title={`Activate ${ clickedItem.first_name } ${ clickedItem.last_name }'s User Account `}
              open={open}
              enableActions={true}
              content={
                <FlexRow>
                  <Typography fontWeight={'bold'} color={'error'}>Are you sure you want to activate the user account for </Typography>
                  <Typography fontWeight={'bold'} >: {clickedItem.first_name} {clickedItem.last_name}? </Typography>
                </FlexRow>
              }
              buttonText="Activate User"
              handleSubmit={handleSubmitActivate}
              isSubmitting={isSubmittingData}
              isSubmittingText={"Activating User, Please wait..."}
              handleClose={handleClose}
            /> : null
      }
    </Box>
  );
}
